<div class="connection-item">
  <div class="left">
    <img
      class="connection-item-logo"
      [src]="connection.image"
      [alt]="connection.title + ' logo'"
    >
  </div>

  <div class="right">
    <div class="connection-item-header">
      <div>
        <div class="connection-item-title">{{ connection.title }}</div>

        @if (showTitleInfoMessage) {
          <div class="color-gray-700 font-size-12 line-height-16">
            {{ titleInfoMessage }}
          </div>
        }
      </div>

      <div [class]="'connection-item-connection-status ' + ConnectionStatusEnum[connection.connectionStatus]">
        {{ connectionStatusLabels[connection.connectionStatus] }}
      </div>
    </div>

    @if (!connection.isLoading) {
      <div class="connection-item-description">
        {{ connection.description }}
      </div>

      <div class="connection-item-controls" *appHasRole="['Admin', 'Manager']">
        @for (button of connection.buttons; track $index) {
          @if (button.displayStatus.includes(connection.connectionStatus)) {
            <button
              type="button"
              class="btn btn-secondary"
              [class.btn-loading]="button.loadingBtn"
              [disabled]="button.disabled || button.loadingBtn"
              (click)="button.action(connection)"
            >
              {{ button.btnTitle }}
            </button>
          }
        }
      </div>
    } @else {
      <div class="d-flex justify-content-center">
        <app-loader
          minHeight="50"
          [loading]="connection.isLoading"
        />
      </div>
    }
  </div>
</div>
